export default __webpack_public_path__ + "static/power-1bda315f7bfd76e2e51a5b35bf7464c1.jpg";